"use strict";

(function ($, Drupal) {
  Drupal.behaviors.Form = {
    attach: function attach() {
      /* FORM
      Element Focus */
      $('form input').focus(function () {
        $(this).addClass('has-value');
      })
      /* blur input fields on unfocus + if has no value */.blur(function () {
        var textVal = $(this).val();
        if (textVal === '') {
          $(this).removeClass('has-value');
        }
      });
      $('form textarea').focus(function () {
        $(this).addClass('has-value');
      })
      // blur input fields on unfocus + if has no value
      .blur(function () {
        var textVal = $(this).val();
        if (textVal === '') {
          $(this).removeClass('has-value');
        }
      });
      $('.form-control input').focus(function () {
        $(this).addClass('has-value');
      })
      /* blur input fields on unfocus + if has no value */.blur(function () {
        var textVal = $(this).val();
        if (textVal === '') {
          $(this).removeClass('has-value');
        }
      });
      $('.form-control textarea').focus(function () {
        $(this).addClass('has-value');
      })
      // blur input fields on unfocus + if has no value
      .blur(function () {
        var textVal = $(this).val();
        if (textVal === '') {
          $(this).removeClass('has-value');
        }
      });
      $('#dd-choose-your-industry').change(function () {
        var value = $(this).val().trim().replace(/ /g, '-');
        var pos = $("[data-type-industry=".concat(value, "]")).offset().top - 100;
        $('body, html').animate({
          scrollTop: pos
        });
      });
    }
  };
})(jQuery, Drupal);